import LoadingScreen from "@/components/LoadingScreen";
import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const Oauth = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {
    if (token) {
      localStorage.setItem("user-token", token);
    }
    navigate("/dashboard");
  }, [searchParams, navigate, token]);

  return <LoadingScreen />;
};

export default Oauth;
